var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-button',_vm._g(_vm._b({attrs:{"color":_vm.color,"size":_vm.size,"routerTo":"onboarding-wizard"}},'core-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",[_vm._v("Create a Free Account")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }